export default "__VITE_ASSET__adc2c70b__"